const hasNative = "scrollRestoration" in window.history;
const initial = hasNative ? window.history.scrollRestoration : "auto";
export const data = { hasNative, initial };
